import React from 'react';
import { AutocompleteRenderInputParams } from '@material-ui/lab/Autocomplete';
import { TextField } from '../../../TextField/TextField';
import { TextFieldSize } from '../../../TextField/tools/TextField.const';
import { ReactComponent as SearchIcon } from 'common-assets/assets/icons/magnifyingGlass.svg';
import { ReactComponent as CloseIcon } from 'common-assets/assets/icons/close.svg';
import IconButton from '@material-ui/core/IconButton';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface AutocompleteRenderInputProps {
  params: AutocompleteRenderInputParams;
  isMobile: boolean;
  searchLabel?: string;
  searchPlaceholder?: string;
  required: boolean;
  ariaDescribedby?: string;
  autocompleteRef: React.RefObject<HTMLInputElement>;
  internalInputValue: string;
  handleClearInput: (event: React.MouseEvent) => void;
}

export const AutocompleteRenderInput: React.FC<AutocompleteRenderInputProps> = ({
  params,
  isMobile,
  searchLabel,
  searchPlaceholder,
  required,
  ariaDescribedby,
  autocompleteRef,
  internalInputValue,
  handleClearInput,
}) => {
  const showClearButton = internalInputValue && internalInputValue.length > 0;
  const [t] = useTranslation('components');
  return (
    <TextField
      {...params}
      size={isMobile ? TextFieldSize.DEFAULT : TextFieldSize.SMALL}
      label={searchLabel}
      placeholder={searchPlaceholder}
      inputProps={{
        'aria-required': required,
        'aria-describedby': ariaDescribedby,
        ...params.inputProps,
      }}
      inputRef={autocompleteRef}
      startAdornment={<SearchIcon aria-hidden={true} />}
      endAdornment={
        showClearButton ? (
          <IconButton size="small" onClick={handleClearInput} aria-label={t('autocomplete.clear-field')}>
            <CloseIcon aria-hidden={true} />
          </IconButton>
        ) : undefined
      }
      InputProps={{
        ...params.InputProps,
        className: clsx(params.InputProps?.className),
      }}
    />
  );
};

